export default "__VITE_ASSET__CmYfe7RD__"